import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"d-flex align-center justify-center flex-column py-12"},[_c('div',{staticClass:"subheader-1 mb-6 font-weight-bold"},[_c('span',[_vm._v(_vm._s(_vm.error.Description[0])+" | "+_vm._s(_vm.error.StatusCode))])])])}
var staticRenderFns = []

export { render, staticRenderFns }